import * as THREE from 'three';
const PI = 3.1415926;
const PIx2 = PI * 2;
const mix = function(v1, v2, f){
	const res = {};
	res.x = v1.x + (v2.x - v1.x)*f;
	res.y = v1.y + (v2.y - v1.y)*f;
	res.z = v1.z + (v2.z - v1.z)*f;
	return res;
}
const mixSingle = function(v1, v2, f){
	return v1 + (v2 - v1)*f;
}
class SmoothLineZone{
	constructor(points){
		this.points = points;
	}
	createPoint(){
		const rnd = Math.random();
		const mp = function(points){
			if(points.length > 1){
				const res = [];
				for(let i=0; i< points.length-1; i++){
					res.push(mix(points[i], points[i+1], rnd));
				};
				return mp(res);
			}else{
				return points[0];
			}
		}
		return mp(this.points);
	}
}
class RestrictedZone{
	constructor(restrictions){
		this.restrictions = restrictions;
	}
	createPoint(){
		return new THREE.Vector3(
			mixSingle(this.restrictions.x[0], this.restrictions.x[1], Math.random()),
			mixSingle(this.restrictions.y[0], this.restrictions.y[1], Math.random()),
			mixSingle(this.restrictions.z[0], this.restrictions.z[1], Math.random())
		)
	}
}
class SphereZone{
	constructor(center, radius){
		this.center = center;
		this.radius = radius;
	}
	createPoint(){
		const r = this.radius * Math.random();
		const tha = PI * Math.random();
		const phi = PIx2 * Math.random();
		return new THREE.Vector3(
			this.center.x + r * Math.sin(tha) * Math.cos(phi),
			this.center.y + r * Math.sin(phi) * Math.sin(tha),
			this.center.z + r * Math.cos(tha)
		);
	}
}
class PointZone{
	constructor(point){
		this.point = point;
	}
	createPoint(){
		return this.point;
	}
}
class CircleZone{
	constructor(center, radius, clockRotateX=0, clockRotateY=0, noFill=false){
		this.center = center;
		this.radius = radius;
		this.clockRotateX = clockRotateX;
		this.clockRotateY = clockRotateY;
		this.noFill = noFill;
	}
	createPoint(){
		const angle = PIx2 * Math.random();
		const rad = this.noFill ? this.radius : Math.random() * this.radius;
		const x = rad * Math.cos(angle);
		const y = rad * Math.sin(angle);
		const rx = x * Math.cos(this.clockRotateY);
		const rzp = x * Math.sin(this.clockRotateY);
		const cosX = Math.cos(this.clockRotateX);
		const rz = rzp * cosX;
		const ry = y * cosX;
		return new THREE.Vector3(
			this.center.x + rx,
			this.center.y + ry,
			this.center.z + rz
		);
	}
}

export {SmoothLineZone, SphereZone, PointZone, CircleZone, RestrictedZone};